export default __webpack_public_path__ + "static/media/logohokkydana.9cb3f5f7.png";